var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"my-modal"}},[_c('div',{staticClass:"modal-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.formattedCGUText)}}),_c('b-button',{on:{"click":_vm.accepteCGA}},[_vm._v("\n      Accepter\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }